import React from 'react'
import styled from '@emotion/styled'
import { TextInput, TextInputProps } from '../inputs'
import { MultiButton } from '../buttons'
import { notEmpty } from 'utils'
import { iconSet } from '../icons'
import * as constants from 'view/styles/constants'

interface SearchInputProps extends TextInputProps {
  dataTestId?: string
}

const SearchInputContainer = styled.div`
  position: relative;
`

const SearchIcon = styled.div`
  position: absolute;
  top: 1px;
  left: 1px;
  height: 24px;
  width: 24px;
`

const StyledTextInput = styled(TextInput)<{ notEmpty: boolean }>`
  padding-left: 24px;
  padding-right: ${props => (props.notEmpty ? '24px' : undefined)};
`

const ClearSearchButton = styled(MultiButton)`
  position: absolute;
  top: 1px;
  right: 1px;
  height: 24px;
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: ${constants.ACCENT_BAD};
  }
`

export class SearchInput extends React.Component<SearchInputProps> {
  render() {
    const { className, dataTestId, ...rest } = this.props
    const searchNotEmpty = notEmpty(this.props.value)

    return (
      <SearchInputContainer data-test-id={`SearchInput-SearchInputContainer-${dataTestId}`} className={className}>
        <SearchIcon>{iconSet.magnifyingGlass}</SearchIcon>
        <StyledTextInput {...rest} onUpdate={this.handleUpdateSearch} notEmpty={searchNotEmpty} />
        {searchNotEmpty && (
          <ClearSearchButton dataTestId={'SearchInput-ClearSearchButton-CloseButton'} onClick={this.handleClearSearch}>
            {iconSet.crossIcon}
          </ClearSearchButton>
        )}
      </SearchInputContainer>
    )
  }

  private handleUpdateSearch = (value: string) => {
    this.props.onUpdate(value)
  }

  private handleClearSearch = () => {
    this.props.onUpdate('')
  }
}
